import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editButton", "checkbox", "checkAll"]

  connect() {
    this.updateButtonState()
  }

  toggleCheckbox() {
    this.updateButtonState()
    this.updateCheckAllState()
  }

  toggleAll() {
    const checkAll = this.checkAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checkAll
    })
    this.updateButtonState()
  }

  updateCheckAllState() {
    if (this.hasCheckAllTarget) {
      const allChecked = this.checkboxTargets.length > 0 && 
                        this.checkboxTargets.every(cb => cb.checked)
      const someChecked = this.checkboxTargets.some(cb => cb.checked)
      
      this.checkAllTarget.checked = allChecked
      this.checkAllTarget.indeterminate = someChecked && !allChecked
    }
  }

  updateButtonState() {
    const enabled = this.checkboxTargets.some(cb => cb.checked)

    this.editButtonTargets.forEach(button => {
      if (enabled) {
        button.disabled = false
        button.classList.remove('btn-outline-secondary', 'disabled')
        button.classList.add('btn-primary')
        button.style.opacity = '1'
      } else {
        button.disabled = true
        button.classList.remove('btn-primary')
        button.classList.add('btn-outline-secondary', 'disabled')
        button.style.opacity = '0.4'
      }
    })
  }
}